import { useQuery } from '@tanstack/react-query';
import { concat } from 'lodash';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

import { mapAllDayparts } from './helpers';

export const useGetDaypartsByLocationGroup = (
  filters: string[] = [],
  enabled = true,
) =>
  useQuery({
    queryKey: queryKeys.defaultAssemblies.all(filters),
    queryFn: () => fetchLocationGroupDayparts(filters),
    enabled,
  });

export const fetchLocationGroupDayparts = async (filters: string[] = []) => {
  const url = `/defaultAssemblies${generateQuery(
    ['dayparts'],
    concat(filters, 'pageSize=0'),
  )}`;
  const response = await requestCCApi({
    url,
  });

  return response.data ? mapAllDayparts(response.includes.dayparts.data) : [];
};
